import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Logo, cx } from "@/lib/ui";
import { useAuth } from "@/context/Auth";

const NAV = [
  { to: "/referor/app", end: true, icon: "fa-gauge", label: "Dashboard" },
  { to: "/referor/app/refer", icon: "fa-handshake", label: "Refer a Business" },
  { to: "/referor/app/earnings", icon: "fa-wallet", label: "Earnings & Payments" },
  { to: "/referor/app/payout", icon: "fa-qrcode", label: "Payout QR" },
];

export default function ReferorLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (user && !user.payout_qr && loc.pathname !== "/referor/app/payout") nav("/referor/app/payout", { replace: true });
  }, [user, loc.pathname, nav]);
  return (
    <div className="min-h-screen bg-slate-50 lg:flex">
      <aside className={cx("fixed inset-y-0 left-0 z-40 w-64 transform border-r border-slate-800 bg-slate-950 p-4 text-slate-300 transition lg:static lg:translate-x-0", open ? "translate-x-0" : "-translate-x-full")}>
        <div className="mb-6"><Logo dark /></div>
        <div className="mb-4 rounded-lg bg-white/5 p-3">
          <p className="text-xs uppercase tracking-wider text-slate-500">Referor</p>
          <p className="truncate text-sm font-semibold text-white">{user?.name}</p>
          <p className="text-xs text-orange-400">{user?.code}</p>
        </div>
        <nav className="space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`referor-nav-${n.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) => cx("flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition", isActive ? "bg-orange-600 text-white" : "hover:bg-white/5")}>
              <i className={`fa-solid ${n.icon} w-4`} /> {n.label}
            </NavLink>
          ))}
          <button onClick={() => { logout(); nav("/referor"); }} data-testid="referor-logout" className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-red-300 hover:bg-white/5"><i className="fa-solid fa-right-from-bracket w-4" /> Logout</button>
        </nav>
      </aside>
      {open && <div className="fixed inset-0 z-30 bg-black/50 lg:hidden" onClick={() => setOpen(false)} />}
      <main className="flex-1 p-4 lg:p-8">
        <button className="mb-4 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm lg:hidden" onClick={() => setOpen(true)}><i className="fa-solid fa-bars" /> Menu</button>
        {!user?.payout_qr && <div className="mb-4 rounded-lg border border-amber-300 bg-amber-50 p-3 text-xs text-amber-800" data-testid="payout-missing-banner"><i className="fa-solid fa-triangle-exclamation mr-1" /> Upload your payout QR to receive payments.</div>}
        <Outlet />
      </main>
    </div>
  );
}
